export default __webpack_public_path__ + "static/media/Hood of Black Whispers.30222636.jpg";